export default __webpack_public_path__ + "static/media/UsingNotes.bd7e047f.mp4";